<template>
  <div class="mb-2">
    <h2 class="text-3xl uppercase"><slot /></h2>
  </div>
</template>

<script>
export default {
  name: "TitleCard",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
